<template>
    <modal-content-container
        id="how-to-read"
        title="Understanding the Charts"
        description=""
    >
        <div class="description">
            This tool aims to make it easy to understand the data for your community. To that end we’ve annotated one of each chart used to help clarify how to read the visuals.
        </div>
        <div
            v-for="(image, i) in images"
            :key="i"
            class="how-to-image"
        >
            <div class="label">
                {{ image.title }}
            </div>
            <img
                :src="image.src"
            >
        </div>
    </modal-content-container>
</template>

<script>
import ModalContentContainer from '@/views/tabs/ModalContentContainer.vue';

export default {
    components: {
        ModalContentContainer
    },
    props: {
        content: {
            type: Array,
            required: true
        }
    },
    computed: {
        images() {
            // eslint-disable-next-line import/no-dynamic-require, global-require
            return this.content.map(({ file, ...rest }) => ({ ...rest, src: require(`@/assets/howToReadCharts/${file}`) }));
        }
    }
};
</script>

<style src="./tabs/common.tab.css" scoped></style>
<style lang="postcss" scoped>
.description {
    max-width: 70%;
}

@screen mobile {
    #how-to-read {
        @apply px-4;
    }
    .description {
        max-width: 100%;
    }
}

.how-to-image {
    @apply mt-16 mb-32;
}
.how-to-image .label {
    @apply mb-8;
}
</style>
